import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { PageDesktop, PageMobile } from '../../components/Page';
import { SideBarContainer } from '../SideBarContainer';
import { getPageContent } from '../../services/getPageContent';
import { EPage } from '../../constants/pages';
import { useApplicationContext } from '../../utils/applicationContext';
import { ConsultationRequestModalContainer } from '../ConsultationRequestModalContainer';

export interface IPageContainerProps {
  page: EPage;
}

export const PageContainer: React.FC<IPageContainerProps> = ({ page }) => {
  const { config } = useApplicationContext();
  const isServiceUnderMaintenance = config.get<boolean>('legal-check.isServiceUnderMaintenance');
  const component = React.useMemo(() => getPageContent(page, isServiceUnderMaintenance), [page]);

  return (
    <>
      <Responsive desktop>
        <PageDesktop sidebar={<SideBarContainer />}>{component}</PageDesktop>
      </Responsive>

      <Responsive phone tablet>
        <PageMobile>{component}</PageMobile>
      </Responsive>

      <ConsultationRequestModalContainer requestSentFrom="Форма проверки недвижимости" />
    </>
  );
};

PageContainer.displayName = 'PageContainer';
